import React, { useState } from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import { FieldRadioModulo } from "../FieldRadioModulo";
import { FieldText } from "../FieldText";

export const DialogEliminarPrefactura = ({
  accept,
  cancel
}) => {
 
    const [selectedValue, setSelectedValue] = useState("");
    const [comentario, setComentario] = useState("");

    const handleChange = (modulo, propiedad, value) => {
        setSelectedValue(value);
    };

    const handleComentarioChange = (id, value) => {
      setComentario(value);
    }

  return (
    <S.Container onClick={cancel}>
      <S.Wrapper onClick={(event) => event.stopPropagation()}>
        <S.TitleBar>
          <S.Close onClick={cancel}>×</S.Close>
        </S.TitleBar>
        <S.Content>
          <h4>Desea eliminar las prefacturas seleccionadas?</h4>
          <S.RadioContainer>
            <FieldRadioModulo
                modulo="exampleModule"
                propiedad="exampleProperty"
                options={[
                    { value: "1", label: "Retornar al estado inicial" },
                    { value: "2", label: "Retornar a gastos" },
                    { value: "3", label: "Retornar a OnBase" },
                ]}
                value={selectedValue}
                handleChange={handleChange}
                readOnly={false}
                hidden={false}
                centered={false}
            />
          </S.RadioContainer>
          {(selectedValue === "1" || selectedValue === "2") && 
            <FieldText
              id='comentarioInput'
              label='Comentario:'
              value={comentario}
              handleChange={handleComentarioChange}
            />
          }
          <S.Buttons>
            <button disabled={selectedValue===""} onClick={() => accept({selectedValue, comentario})}>Aceptar</button>
            <button type="cancel" onClick={cancel}>Cancelar</button>
          </S.Buttons>
        </S.Content>
      </S.Wrapper>
    </S.Container>
  );
};

DialogEliminarPrefactura.propTypes = {
  accept: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};
